import React from "react";
import ProjectItem from "../PageComponents/ProjectItem";
import AgeCalculator from "../../assets/age-calculator-preview.jpg";
import Sunnyside from "../../assets/sunnyside-preview.jpg";
import TimeTracking from "../../assets/time-tracking-preview.jpg";
import LittleLemon from "../../assets/little-lemon-home.png";
import "./ProjectGrid.css";

export default function ProjectGrid() {
  return (
    <div>
      <div className="container-custom project-grid">
        <h2>Projects</h2>
        <div className="d-flex flex-column align-items-center justify-content-center">
          <div className="grid d-md-flex align-items-center justify-content-center">
            <ProjectItem
              image={LittleLemon}
              headline="Little Lemon restaurant's website"
              description="Combining the skills and knowledge that I applied throughout the Meta course to write code to create a form that handles table bookings for the Little Lemon restaurant. A table bookings form will all be assessed in the peer review submission."
              liveSiteUrl="https://sue-little-lemon-meta.netlify.app/"
              gitHubUrl="https://github.com/shoproizoshlo/meta-little-lemmon"
            />
            <ProjectItem
              image={Sunnyside}
              headline="Sunnyside agency landing page"
              description="This is the challenge from the Frontend Mentor, where users should be able to: view the optimal layout for the site depending on their device's screen size, and see hover states for all interactive elements on the page"
              liveSiteUrl="https://sue-sunnyside-agency-landing-page.netlify.app/"
              gitHubUrl="https://github.com/shoproizoshlo/sunnyside-agency-landing-page-main"
            />
          </div>
          <div className="grid d-md-flex align-items-center justify-content-center">
            <ProjectItem
              image={AgeCalculator}
              headline="Age calculator app solution"
              description="View an age in years, months, and days after submitting a valid date through the form and receive validation errors."
              liveSiteUrl="https://sue-age-calculator-app.netlify.app/"
              gitHubUrl="https://github.com/shoproizoshlo/age-calculator-app-main"
            />
            <ProjectItem
              image={TimeTracking}
              headline="Time tracking dashboard"
              description="I built out dashboard and get it looking as close to the design as possible. Also had some practice working with JSON data. The text for the previous period's time changes based on the active timeframe."
              liveSiteUrl="https://sue-time-tracking-dashboard.netlify.app/"
              gitHubUrl="https://github.com/shoproizoshlo/time-tracking-dashboard-main"
            />
          </div>
        </div>
      </div>
    </div>
  );
}
